
import { Button } from "@/components/ui/button";
import { PlusCircle } from "lucide-react";

interface EmailSettingsHeaderProps {
  onAddAccount: () => void;
}

export const EmailSettingsHeader = ({ onAddAccount }: EmailSettingsHeaderProps) => {
  return (
    <div className="space-y-4">
      <div>
        <h2 className="text-2xl font-bold tracking-tight">Email Accounts</h2>
        <p className="text-muted-foreground">
          Connect your email accounts to use with Maia. We support Gmail, Exchange, and IMAP/SMTP.
        </p>
      </div>
      <Button onClick={onAddAccount} className="h-9">
        <PlusCircle className="h-4 w-4 mr-2" />
        Add Account
      </Button>
      <div className="p-3 bg-blue-50 text-blue-800 rounded-md text-sm">
        <p className="font-medium">Note about Exchange accounts:</p>
        <p className="mt-1">
          Exchange support is provided for testing purposes. For production use, we recommend using a specialized Exchange service. Due to edge function limitations, full Exchange functionality may be restricted.
        </p>
      </div>
    </div>
  );
};
